module.exports = __webpack_public_path__ + "img/1462079388.05ff3f5a.jpg";